
import 'pages/settings/permissions/permissions-users.tag'
import 'pages/settings/permissions/permissions-roles.tag'
riot.tag2('permissions', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#permissions-users">Пользователи</a></li>\n    <li><a data-toggle="tab" href="#permissions-roles">Роли</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="permissions-users">\n      <permissions-users></permissions-users>\n    </div>\n    <div class="tab-pane fade" id="permissions-roles">\n      <permissions-roles></permissions-roles>\n    </div>\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/settings/permissions/permissions.tag